import axios from "axios";

export const Ajax = {
    POST: function (uri, data, headers = {}) {
        this.methods.axiosConfigure()
        data.append('_token', Ajax.methods.getCsrfToken());
        return axios.post(this.methods.requestUrl(uri), data, headers)
    },
    DELETE:function (uri) {
        this.methods.axiosConfigure()
        data.append('_token', Ajax.methods.getCsrfToken());
        return axios.delete(this.methods.requestUrl(uri),  {})
    },
    methods: {
        axiosConfigure: function () {
            axios.defaults.withCredentials = true
            axios.defaults.headers.common = {
                'Content-Type': 'multipart/form-data',
                'X-CSRF-TOKEN': Ajax.methods.getCsrfToken(),
                'X-Requested-With': 'XMLHttpRequest',
            };
        },
        requestUrl: function (url) {
            return url + '?requestId=' + Math.round(new Date().getTime() / 1000)
        },
        getCsrfToken: function () {
            const tokenElements = document.getElementsByName("csrf-token")
            let token = null
            if (tokenElements[0])
                token = tokenElements[0].getAttribute('content')

            return token
        }
    }
}
